import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Landing from "./pages/Landing";
import QueuePage from "./pages/QueuePage";
import VacationsPage from "./pages/VacationsPage";
import WinnersPage from "./pages/WinnersPage";
import CharityImpactPage from "./pages/CharityImpactPage";
import PrivacyPage from "./pages/PrivacyPage";
import MissionPage from "./pages/MissionPage";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import AdminPage from "./pages/AdminPage";
import PaymentResult from "./pages/PaymentResult";
import TermsPage from "./pages/TermsPage";
import PartnersPage from "./pages/PartnersPage";
import BrokerDashboard from "./pages/BrokerDashboard";
import CooPortal from "./pages/CooPortal";
import InvitePage from "./pages/InvitePage";
import FinishJoinPage from "./pages/FinishJoinPage";
import { GoogleCallback } from "./components/GoogleCallback";

const Protected = ({ children, admin, staff }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400 font-mono-lux text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (staff && !["admin", "coo"].includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
};

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleCallback />;
  return (
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/queue" element={<QueuePage />} />
            <Route path="/vacations" element={<VacationsPage />} />
            <Route path="/voyagers" element={<WinnersPage />} />
            <Route path="/winners" element={<Navigate to="/voyagers" replace />} />
            <Route path="/impact" element={<CharityImpactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/mission" element={<MissionPage />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin" element={<Protected admin><AdminPage /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentResult /></Protected>} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/broker" element={<Protected><BrokerDashboard /></Protected>} />
            <Route path="/coo" element={<Protected staff><CooPortal /></Protected>} />
            <Route path="/invite" element={<InvitePage />} />
            <Route path="/join/finish" element={<FinishJoinPage />} />
            <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <main className="min-h-screen">
          <AppRoutes />
        </main>
        <Footer />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
